import apiHelper from "./apiHelper";
import { message } from "antd";

export const getApiKeys = async () => {
  const url = "/key";
  const response: any = await apiHelper.get(url, {});
  if (response?.data?.data?.length === 0) {
    message.error("No Api keys found!");
  }
  return response;
};

export const createApiKey = async (body: { clientName: string; clientEmail: string }) => {
  const url = "/key";
  const response: any = await apiHelper.post(url, body);
  if (response.data.statusCode === 201) {
    return { success: true, key: response.data.data.key };
  }
  message.error(response.data.message);
  return undefined;
};

export const updateApiKey = async (
  id: string,
  body: { clientName: string; clientEmail: string; isBlocked: boolean }
) => {
  const url = `/key/${id}`;
  const response: any = await apiHelper.patch(url, body);

  if (response.data.statusCode === 200) {
    return response.data.data;
  }

  message.error(response.data.message);
  return null;
};

export const deleteApiKey = async (id: string) => {
  const url = `/key/${id}`;
  const response: any = await apiHelper.delete(url, {});
  if (response.data.statusCode === 200) {
    return { success: true };
  }
  message.error(response.data.message);
  return [];
};

export const refreshApiKey = async (id: string) => {
  const url = `/key/regenerate/${id}`;
  const response: any = await apiHelper.patch(url, {});
  if (response.data.statusCode === 200) {
    return { success: true, key: response.data.data };
  }
  message.error(response.data.message);
  return undefined;
};
